"use strict";

import React, {useCallback, useEffect} from 'react';
import AccountAddressFormInput from "./AccountAddressFormInput";
import {useForm} from "react-hook-form";
import formatPhoneNumber from "../../formatPhoneNumber";
import formInputErrorClassName from "../../formInputErrorClassName";
import fetchAddressSuggestionDetails from "../../fetchAddressSuggestionDetails";

const AccountAddressForm = ({data={}, type='billing', showAddressName=false,
                            showAddressLocationType=true, onSubmit=()=>{},
                            onCancel=()=>{},children}) => {
    const shouldAutoSuggestAddresses = true;
    //rename autosuggest form input something generic to thwart browser autocomplete from popping up
    const autoSuggestInputName = 'data_input_field_1';
    const formattedData = {...data, zip: `${data.zip5}${data.zip4}`, phone: formatPhoneNumber( data.phone || '' ),};
    // remove zip5 and zip4 so we only have one source of data for zip
    delete formattedData.zip5;
    delete formattedData.zip4;
    if(shouldAutoSuggestAddresses) {
        formattedData[autoSuggestInputName] = data.address;
        //since we are using address suggestions with a generic data property name lets remove the original
        // address property so there are not two separate ones
        delete formattedData.address;
    }
    const {
        register,
        getValues,
        setValue,
        handleSubmit,
        control,
        reset,
        formState: {errors},
    } = useForm({
        defaultValues: {...formattedData,},
    });
    const handleSuggestedAddressSelect = useCallback((e, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method })=>{
        fetchAddressSuggestionDetails(suggestion).then((results)=>{
            reset({...getValues(), ...results, address2: '',});
        });
    }, [fetchAddressSuggestionDetails]);

    useEffect(()=>{
        reset({...getValues(), ...data, ...formattedData,});
    }, [data, reset, getValues]);

    function formInputClassName(name = '') {
        return formInputErrorClassName(name, errors);
    }

    function handleCancelClick(e){
        e.preventDefault();
        reset({...data, ...formattedData,});
        onCancel();
    }

    function handleAddressFormSubmit(formData={}){
        const updatedFormData = {...formData};
        if(shouldAutoSuggestAddresses && !!formData[autoSuggestInputName]){
            updatedFormData.address = formData[autoSuggestInputName];
            delete updatedFormData[autoSuggestInputName];
        }
        onSubmit(updatedFormData, type);
    }

    return (
        <form id="account__address__form"
              className="account__address__form"
              style={{position: 'relative'}}
              onSubmit={handleSubmit(handleAddressFormSubmit)}
              noValidate >
            <AccountAddressFormInput type={type}
                                     showAddressName={showAddressName}
                                     showAddressLocationType={showAddressLocationType}
                                     register={register}
                                     control={control}
                                     setValue={setValue}
                                     errors={errors}
                                     getInputClassName={formInputClassName}
                                     autoSuggestAddress={shouldAutoSuggestAddresses}
                                     autoSuggestInputName={autoSuggestInputName}
                                     onSuggestedAddressSelect={handleSuggestedAddressSelect} />
            {!!children && React.Children.map(children, (child) => {
                const additionalProps = React.isValidElement(child) ? {onCancelClick: handleCancelClick,} : {};
                return(React.cloneElement(child, additionalProps));
            })}
        </form>
    );
};

export default AccountAddressForm;
